import { useReveal } from "../hooks/useReveal";
import { FALSE_BELIEFS } from "../lib/copy";

export default function Letter() {
  const ref = useReveal();
  return (
    <section ref={ref} className="py-28 md:py-36" style={{ background: "rgba(255,255,255,0.015)" }} data-testid="letter-section">
      <div className="max-w-[760px] mx-auto px-6">
        <p className="section-label mb-10 reveal-up">[003] — A LETTER FROM MATTHEW</p>
        <p className="reveal-up mb-10 text-lg italic" style={{ color: "rgba(240,236,228,0.6)" }}>To Veterans and Service Members Considering Homeownership,</p>
        <p className="reveal-up mb-8" style={{ color: "rgba(240,236,228,0.65)", lineHeight: 1.8, fontSize: 15 }}>
          If you've started looking into your VA home loan benefit, you've probably heard at least one of these three things. Each one has stopped good buyers from even starting:
        </p>
        <div className="space-y-4 mb-12">
          {FALSE_BELIEFS.map((b, i) => (
            <div key={i} className="belief-card reveal-slide" data-testid={`false-belief-card-${i + 1}`}>
              <span className="belief-x">✗</span>
              <span>{b}</span>
            </div>
          ))}
        </div>
        <div className="reveal-up mb-12" style={{ height: 1, background: "linear-gradient(90deg, #3D7BFF, transparent)" }} />
        <div className="space-y-6 reveal-up" style={{ color: "rgba(240,236,228,0.65)", lineHeight: 1.85, fontSize: 15 }} data-testid="revelation-paragraphs">
          <p>
            First, your credit scores. The VA itself does not establish one universal minimum credit score for VA loans, although individual lenders and loan programs may have their own requirements. So don't assume you're not ready—or that you can't be approved. The better first step is understanding your complete financial picture and what options may be available to you.
          </p>
          <p>
            Second, VA financing doesn't automatically make your offer uncompetitive. The strength of any offer depends on the circumstances, but an experienced lending team can help your Realtor understand the financing, anticipate potential issues, and confidently communicate the strength of your financing to the Listing Agent and Seller—helping put your Realtor in a stronger position to negotiate and get your offer accepted.
          </p>
          <p>
            Finally, not every mortgage company approaches VA lending the same way. The VA establishes the program guidelines, but individual lenders may add their own requirements—often called “lender overlays”—that go beyond VA guidelines. Working with a Mortgage Loan Advisor who truly understands the VA loan program, knows how to navigate lender requirements, and communicates effectively with your Realtor can make a meaningful difference in your homebuying experience.
          </p>
          <p>
            That's what we'll unpack together in this webinar.
          </p>
        </div>
        <p className="reveal-up mt-10 font-bold" style={{ color: "#3D7BFF" }} data-testid="letter-signoff">— Matthew Lake-Nestor<br /><span style={{ fontWeight: 500, color: "rgba(240,236,228,0.6)" }}>Property Lending Team @ NEXA Lending</span></p>
      </div>
    </section>
  );
}
